import { render, staticRenderFns } from "./Portal-Settings.vue?vue&type=template&id=1ca3a7ac&"
import script from "./Portal-Settings.vue?vue&type=script&lang=js&"
export * from "./Portal-Settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports